import { memo, useState } from 'react'
import { useNavigate } from 'react-router'
import GoldImg from '@/assets/gold.png'
import QRCodeImg from '@/assets/qrcode.png'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { Modal } from 'antd'

export default memo(function UserAction() {
	const navigate = useNavigate()
	const { userInfo } = useSelector((state: any) => state.user)
	const [isModalVisible, setIsModalVisible] = useState(false)

	const showModal = () => {
		setIsModalVisible(true)
	}

	const handleCancel = () => {
		setIsModalVisible(false)
	}

	return (
		<>
			<GoldWrap>
				<img src={GoldImg} alt='金币' />
				<div>金币余额：{userInfo.coin_balance}</div>
			</GoldWrap>
			<GoldActionWrap>
				<div onClick={showModal}>去充值</div>
				<div
					onClick={() => {
						navigate('/gold-logs-management')
					}}
				>
					查明细
				</div>
			</GoldActionWrap>
			<Modal title='扫码充值' visible={isModalVisible} onCancel={handleCancel} footer={null} centered width={400}>
				<QRCodePlaceholder>
					<p>请扫描下方二维码进行充值</p>
					<QRCodeImage>
						<img src={QRCodeImg} alt='充值二维码' style={{ width: '200px', height: '200px', margin: '0 auto' }} />
					</QRCodeImage>
					<p>打开微信/支付宝扫一扫完成充值</p>
				</QRCodePlaceholder>
			</Modal>
		</>
	)
})

export const GoldWrap = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 0;

	img {
		width: 16px;
		height: 16px;
		margin-right: 8px;
	}
`

export const GoldActionWrap = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-around;

	div {
		width: 50%;
		color: #287ed8;
		cursor: pointer;
		text-align: center;
		transition: color 0.3s;
		padding: 8px 0;

		&:hover {
			color: #1a5eb9;
		}
	}
`

// 新增样式组件
const QRCodePlaceholder = styled.div`
	text-align: center;
	padding: 20px 0;

	p {
		margin: 15px 0;
		color: #666;
	}
`

const QRCodeImage = styled.div`
	margin: 20px 0;
`
